<template>
  <div>
    <div v-if="!this.isLoadingPatient && this.loaded">
      <medical-history ref="history" :is-edit="true"></medical-history>
      <div style="text-align: right; margin-right: 4px; margin-top: 15px;">
        <md-button slot="footer" class="md-primary" @click="editPatient"> Save </md-button>
      </div>
    </div>
    <loader :is-visible="isLoadingPatient" />
  </div>
</template>

<script>
import loader from "@/components/GlobeChek/loader.vue"
import MedicalHistory from "@/pages/Auth/Wizard/Patient_Registration/2_MedicalHistory.vue"
import Swal from "sweetalert2"
import { mapGetters, mapActions } from "vuex"

export default {
  components: {
    MedicalHistory,
    loader
  },
  data() {
    return {
      loaded: false,
      isLoadingPatient: false
    }
  },
  computed: {
    ...mapGetters([
      "ptPrereg",
      "patientsList",
      "totalPatients",
      "ptPersonal",
      "ptMedical",
      "ptHistory",
      "ptFamHist",
      "ptEditInfo"
    ]),
    isLoaded() {
      return this.loaded
    },
    sendGlasses() {
      return this.ptPrereg.medical.correctiveLens == 'I wear Glasses'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and Contacts'
        || this.ptPrereg.medical.correctiveLens == 'I wear a Bifocal or Progressive'
        || this.ptPrereg.medical.correctiveLens == 'I wear OTC readers'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and SCL'
        || this.ptPrereg.medical.correctiveLens == 'I wear SCL'
    },
    sendContacts() {
      return this.ptPrereg.medical.correctiveLens == 'I wear Contacts'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and Contacts'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and SCL'
        || this.ptPrereg.medical.correctiveLens == 'I wear SCL'
    }
  },
  async mounted() {
    await this.loadData()
    this.loaded = true
  },
  methods: {
    ...mapActions(["updatePatient", "listAllPatients", "listPatientById", "removePatient", "updateUserStatus"]),
    async validate() {
      return await this.$refs["history"].validate()
    },
    async loadData() {
      this.isLoadingPatient = true

      const personId = sessionStorage.getItem("personID")

      if (!personId) {
        return
      }

      this.listPatientById({ patientId: personId, usePersonId: true }).then(response => {
        this.isLoadingPatient = false
        this.loaded = true
        const detailedPatient = response.patient

        this.ptEditInfo.ID = detailedPatient.ID
        this.ptEditInfo.personID = detailedPatient.personID
        this.ptEditInfo.userID = detailedPatient.userID
        this.ptEditInfo.orgId = detailedPatient.orgID

        this.ptPersonal.firstName = detailedPatient.person.firstName
        this.ptPersonal.lastName = detailedPatient.person.lastName
        this.ptPersonal.email = detailedPatient.person.email
        this.ptPersonal.DOB = detailedPatient.person.dob ? detailedPatient.person.dob.slice(0, 10) : ""
        this.ptPersonal.gender = detailedPatient.person.gender
        this.ptPersonal.height = detailedPatient.height
        this.ptPersonal.cellPhone = detailedPatient.person.cellNumber
        this.ptPersonal.allowSMS = detailedPatient.person.allowSMS
        this.ptPersonal.insurance = detailedPatient.insurance

        if (detailedPatient.address) {
          this.ptPersonal.address_L1 = detailedPatient.address.address1
          this.ptPersonal.address_L2 = detailedPatient.address.address2
          this.ptPersonal.city = detailedPatient.address.city
          this.ptPersonal.state = detailedPatient.address.state
          this.ptPersonal.zip = detailedPatient.address.zipCode
          this.ptPersonal.country = detailedPatient.address.country
          this.ptPersonal.id = detailedPatient.address.id
        }

        this.ptMedical.chiefComplaint = detailedPatient.chiefComplaint
        this.ptMedical.issues = detailedPatient.issues

        this.ptMedical.correctiveLens = detailedPatient.wearCorrectiveLense

        this.ptMedical.glassesHistory = detailedPatient.glassesHistory
        this.ptMedical.contactsHistory = detailedPatient.contactsHistory

        if (detailedPatient.medicalHistory) {
          this.ptMedical.previousEyeSurgery = detailedPatient.medicalHistory.surgery
          this.ptMedical.historyDiabetes = detailedPatient.medicalHistory.diabetes
          this.ptMedical.historyCancer = detailedPatient.medicalHistory.cancer
          this.ptHistory.stroke = detailedPatient.medicalHistory.stroke
          this.ptHistory.migraines = detailedPatient.medicalHistory.migraines
          this.ptHistory.heartDisease = detailedPatient.medicalHistory.heart
          this.ptHistory.liverDisease = detailedPatient.medicalHistory.liver
          this.ptHistory.highCholesterol = detailedPatient.medicalHistory.cholesterol
          this.ptHistory.highBloodPressure = detailedPatient.medicalHistory.pressure
          this.ptHistory.other = detailedPatient.medicalHistory.others
        }

        if (detailedPatient.familyHistory) {
          this.ptFamHist.stroke = detailedPatient.familyHistory.stroke
          this.ptFamHist.migraines = detailedPatient.familyHistory.migraines
          this.ptFamHist.diabetes = detailedPatient.familyHistory.diabetes
          this.ptFamHist.cancer = detailedPatient.familyHistory.cancer
          this.ptFamHist.glaucoma = detailedPatient.familyHistory.glaucoma
          this.ptFamHist.alzheimers = detailedPatient.familyHistory.alzheimers
          this.ptFamHist.heartDisease = detailedPatient.familyHistory.heart
          this.ptFamHist.liverDisease = detailedPatient.familyHistory.liver
          this.ptFamHist.highCholesterol = detailedPatient.familyHistory.cholesterol
          this.ptFamHist.highBloodPressure = detailedPatient.familyHistory.pressure
          this.ptFamHist.macularDegeneration = detailedPatient.familyHistory.macDegen
          this.ptFamHist.other = detailedPatient.familyHistory.other
        }
      })
    },
    definePayload() {
      const orgId = this.ptPrereg.editInfo.orgId

      const data = {
        id: this.ptPrereg.editInfo.ID,
        chiefComplaint: this.ptPrereg.medical.chiefComplaint,
        issues: this.ptPrereg.medical.issues,
        wearCorrectiveLense: this.ptPrereg.medical.correctiveLens,
        glassesHistory: this.sendGlasses ? this.ptPrereg.medical.glassesHistory : null,
        contactsHistory: this.sendContacts ? this.ptPrereg.medical.contactsHistory : null,
        height: this.ptPrereg.personal.height,
        userType: "Patient",
        insurance: this.ptPrereg.personal.insurance,
        history: {
          id: null,
          patientID: null,
          surgery: this.ptPrereg.medical.previousEyeSurgery ? Number(this.ptPrereg.medical.previousEyeSurgery) : 0,
          cancer: this.ptPrereg.medical.historyCancer ? Number(this.ptPrereg.medical.historyCancer) : 0,
          diabeties:
            this.ptPrereg.medical.historyDiabetes != "None" ? Number(this.ptPrereg.medical.historyDiabetes) : 0,
          others: this.ptPrereg.personalHistory.other || "",
          cholestrol: String(this.ptPrereg.personalHistory.highCholesterol),
          heart: String(this.ptPrereg.personalHistory.heartDisease),
          liver: String(this.ptPrereg.personalHistory.liverDisease),
          migranes: String(this.ptPrereg.personalHistory.migraines),
          pressure: String(this.ptPrereg.personalHistory.highBloodPressure),
          stroke: String(this.ptPrereg.personalHistory.stroke)
        },
        familyHistory: {
          id: null,
          patientID: this.ptPrereg.editInfo.ID,
          alzheimers: String(this.ptPrereg.familyHistory.alzheimers),
          cancer: String(this.ptPrereg.familyHistory.cancer),
          cholesterol: String(this.ptPrereg.familyHistory.highCholesterol),
          diabetes: String(this.ptPrereg.familyHistory.diabetes),
          glaucoma: String(this.ptPrereg.familyHistory.glaucoma),
          heart: String(this.ptPrereg.familyHistory.heartDisease),
          liver: String(this.ptPrereg.familyHistory.liverDisease),
          macDegen: String(this.ptPrereg.familyHistory.macularDegeneration),
          migraines: String(this.ptPrereg.familyHistory.migraines),
          pressure: String(this.ptPrereg.familyHistory.highBloodPressure),
          stroke: String(this.ptPrereg.familyHistory.stroke),
          other: this.ptPrereg.familyHistory.other || ""
        },
        address: {
          id: this.ptPrereg.personal.id,
          address1: this.ptPrereg.personal.address_L1,
          address2: this.ptPrereg.personal.address_L2,
          city: this.ptPrereg.personal.city,
          state: +this.ptPrereg.personal.state,
          country: this.ptPrereg.personal.country.toString(),
          zipCode: this.ptPrereg.personal.zip
        },
        person: {
          id: this.ptPrereg.editInfo.personID,
          firstName: this.ptPrereg.personal.firstName,
          lastName: this.ptPrereg.personal.lastName,
          title: "",
          email: this.ptPrereg.personal.email,
          cellNumber: this.ptPrereg.personal.cellPhone,
          allowSMS: this.ptPrereg.personal.allowSMS || false,
          gender: this.ptPrereg.personal.gender ? this.ptPrereg.personal.gender.toLowerCase() : "",
          DOB: new Date(this.ptPrereg.personal.DOB).toISOString().slice(0, 19).replace("T", " "),
          comments: "",
          languages: null,
          dob: new Date(this.ptPrereg.personal.DOB).toISOString().slice(0, 19).replace("T", " ")
        },
        height1: this.ptPrereg.personal.height.split("'")[0] || "",
        height2: this.ptPrereg.personal.height.split("'")[1] || "",
        orgID: orgId[0],
        organisations: Array.isArray(orgId) ? orgId.map(i => i.orgId || i) : [orgId && orgId.orgId ? orgId.orgId : orgId]
      }
      return data
    },
    async editPatient() {
      this.isLoadingPatient = true

      const validation = await this.validate()
      if (!validation) {
        return
      }

      let payload = this.definePayload()
      payload.address.state = this.ptPrereg.personal.state.toString()
      payload.address.country = this.ptPrereg.personal.country.toString()
      const patientId = this.ptPrereg.editInfo.ID
      try {
        await this.updatePatient({ patientId, payload })
        await this.loadData()
        this.isLoadingPatient = false
        Swal.fire({
          title: "Patient Updated",
          text: "Patient has been updated successfully",
          icon: "success",
          confirmButtonText: "OK"
        }).then(() => {
          this.$emit("close", true)
        })
      } catch (e) {
        console.log(e)
        const errorMsg = e.message || `An error occurred while updating the patient.`
        Swal.fire({
          title: "Error",
          text: errorMsg,
          icon: "error",
          confirmButtonText: "OK"
        })
      } finally {
        this.isLoadingPatient = false
      }
    }
  }
}
</script>
